(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wf-help"] && !Shopify.designMode) return;
  try {
    
  function openWorkForceQuestion() {
    const target = document.getElementById(window.location.hash.slice(1));
    if (target instanceof HTMLDetailsElement && target.classList.contains('wf-disclosure')) target.open = true;
  }
  window.addEventListener('hashchange', openWorkForceQuestion);
  document.addEventListener('shopify:section:load', openWorkForceQuestion);
  openWorkForceQuestion();

  } catch(e) { console.error(e); }
})();
})();
